module.exports = __webpack_public_path__ + "static/dnicon2-64a5c3b7c06b1f213d1f205fdaa4de2c.png";